import type { ChannelShareData } from "@expert/sales-tools";

import { getMappedIntent, useCallDetailsStore } from "@expert/sales-tools";
import { Partner } from "@expert/shared-types";

import type { IVRInfo, VoiceTask } from "@/sdk";

import { isVoiceTask, useMostRecentTask, usePartner } from "@/sdk";

export function useIVRInfo() {
    const task = useMostRecentTask();
    const voiceTask = isVoiceTask(task) ? task : null;
    const partner = usePartner();
    const callDetails = useCallDetailsStore((state) => state.callDetails);
    return getIVRInfo(partner, voiceTask, callDetails);
}

function getIVRInfoFromCSD(callDetails: ChannelShareData) {
    const {
        INTENT: intent,
        SUMMARY: summary,
        CONVERSATIONAL_SUMMARY: conversationalSummary,
        CUSTOMER_NAME: customerName,
        ORDER_NUMBER: orderNumber,
        PRODUCT_LINK: productLink,
        PRODUCT_TITLE: productTitle,
        BRAND_PHONE_NUMBER: brandPhoneNumber,
        SUPPORT_PHONE_NUMBER: supportPhoneNumber,
        ACCOUNT_ID: accountId,
    } = callDetails;

    return {
        intent,
        summary,
        customerName,
        orderNumber,
        productLink,
        conversationalSummary,
        productTitle,
        brandPhoneNumber,
        supportPhoneNumber,
        accountId,
    } as IVRInfo;
}

export function getIVRInfo(partner: Partner, voiceTask: VoiceTask | null, callDetails?: ChannelShareData) {
    const {
        intent: intentFromVoiceTask,
        summary: summaryFromVoiceTask,
        customerName: customerNameFromVoiceTask,
        orderNumber: orderNumberFromVoiceTask,
        productLink: productLinkFromVoiceTask,
        conversationalSummary: conversationalSummaryFromVoiceTask,
        productTitle: productTitleFromVoiceTask,
        brandPhoneNumber: brandPhoneNumberFromVoiceTask,
        supportPhoneNumber: supportPhoneNumberFromVoiceTask,
        accountId: accountIdFromVoiceTask,
    } = voiceTask?.ivrInfo || {};

    const {
        intent: intentFromCSD,
        summary: summaryFromCSD,
        customerName: customerNameFromCSD,
        orderNumber: orderNumberFromCSD,
        productLink: productLinkFromCSD,
        conversationalSummary: conversationalSummaryFromCSD,
        productTitle: productTitleFromCSD,
        brandPhoneNumber: brandPhoneNumberFromCSD,
        supportPhoneNumber: supportPhoneNumberFromCSD,
        accountId: accountIdFromCSD,
    } = getIVRInfoFromCSD(callDetails ?? useCallDetailsStore.getState().callDetails);

    const intent = intentFromVoiceTask ? getMappedIntent(intentFromVoiceTask, partner) : intentFromCSD;
    const summary = summaryFromVoiceTask ?? summaryFromCSD;
    const conversationalSummary = conversationalSummaryFromVoiceTask ?? conversationalSummaryFromCSD;
    const customerName = customerNameFromVoiceTask ?? customerNameFromCSD;
    const orderNumber = orderNumberFromVoiceTask ?? orderNumberFromCSD;
    const productLink = productLinkFromVoiceTask ?? productLinkFromCSD;
    const productTitle = productTitleFromVoiceTask ?? productTitleFromCSD;
    const brandPhoneNumber = brandPhoneNumberFromVoiceTask ?? brandPhoneNumberFromCSD;
    const supportPhoneNumber = supportPhoneNumberFromVoiceTask ?? supportPhoneNumberFromCSD;
    const accountId = accountIdFromVoiceTask ?? accountIdFromCSD;

    return {
        ...voiceTask?.ivrInfo,
        intent,
        summary,
        customerName,
        orderNumber,
        productLink,
        conversationalSummary,
        productTitle,
        brandPhoneNumber,
        supportPhoneNumber,
        accountId,
    };
}
